module.exports = __webpack_public_path__ + "static/media/18ECA17.823f0223.jpg";